"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  TopicContainer: true
};
Object.defineProperty(exports, "TopicContainer", {
  enumerable: true,
  get: function get() {
    return _TopicContainer.default;
  }
});

var _TopicFooterContent = require("./TopicFooterContent");

Object.keys(_TopicFooterContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TopicFooterContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TopicFooterContent[key];
    }
  });
});

var _TopicContainer = _interopRequireDefault(require("./TopicContainer"));